import {t} from "../../../i18n";
import React from 'react';
import LoaderBasic from "../../../commonComponent/loader/LoaderBasic";
import ReservationButton from "../../../commonComponent/reservation/ReservationButton";

const NewsletterReserve = () => {

    const [clickSubscribe, setClickSubscribe] : any= React.useState(t("newsletter.subscribe"));
    const subscribeToNewsletter = (e: any) => {
        e.preventDefault();
        if (e.target.previousSibling.value === "") {
            return;
        }

        setClickSubscribe(<LoaderBasic/>);

        setTimeout(() => {
            setClickSubscribe(t("newsletter.thanks"));
        },2500);

        setTimeout(() => {
            setClickSubscribe(t("newsletter.subscribe"));
        }, 6000);
    }

    return (
        <section className="content-row newsletter-row">

            <article className="content-panel content-panel--secondary">
                <h2 className="section-heading">{t("newsletterReserveTitle")}</h2>
                <div className="flex flex-col mt-4">
                    <p className="section-copy">{t("newsletterReserveText")}</p>
                    <ReservationButton className="newsletter-reserve" />

                </div>
            </article>

            <article className="content-panel">
                <h2 className="section-heading">{t("newsletter.title")}</h2>

                <div className="newsletter-fields">
                    <p className="section-copy">{t("newsletterText")}</p>
                    <input className="newsletter-input" aria-label={t("newsletter.email")} autoComplete="email" type="email" placeholder={t("newsletter.placeholder")}/>
                    <button onClick={(e) => subscribeToNewsletter(e)} className={`ui-button newsletter-submit${clickSubscribe === t("newsletter.thanks") ? " is-success" : ""}`}>{clickSubscribe}</button>
                </div>

            </article>
        </section>
    );
};

export default NewsletterReserve;
